import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { styled } from '@material-ui/core/styles';
import { Typography, Button } from '@material-ui/core';
import Logo from '../components/Logo';
import { MHidden } from '../components/@material-extend';
import { Icon } from '@iconify/react';
import cornerupleft from '@iconify/icons-eva/corner-up-left-fill';


// ----------------------------------------------------------------------

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  zIndex: 9,
  lineHeight: 0,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  padding: theme.spacing(3),
  justifyContent: 'space-between',
  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-start',
    padding: theme.spacing(7, 5, 0, 7)
  }
}));

// ----------------------------------------------------------------------

BotaoVoltarLayout.propTypes = {
  children: PropTypes.node
};

export default function BotaoVoltarLayout({ children }) {
  return (
    <HeaderStyle>
      <RouterLink to="/">
        <Button
          className="btn-cinza"
          component={RouterLink}
          to="login"
        >
          <Icon icon={cornerupleft} />&nbsp; Voltar
        </Button>
      </RouterLink>

      <MHidden width="smDown">
        <Typography
          variant="body2"
          sx={{
            mt: { md: -2 }
          }}
        >
          {children}
        </Typography>
      </MHidden>
    </HeaderStyle>
  );
}
